import React, { useEffect, useState } from "react";
import OnboardingHeader from "../Onboarding/OnboardingHeader";
import "./SubscriptionPlan.css";
import Icons from "../../../../Config/Images";
import { useDispatch } from "react-redux";
import {
  AddSubscriptionAPI,
  getActiveSubscriptionAPI,
  getSubscriptionAPI,
  updateSubscriptionAPI,
} from "../../../../Store/Action/subscriptionAction";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderBlack from "../../WelcomeScreen/Common/Header";
import Footer from "../../Layout/Footer/Footer";
import Header from "../../Layout/Header/Header";
import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";

export const PlanCard = ({
  name,
  description,
  price,
  duration,
  benefits,
  onAddSubscription,
  onUpdateSubscription,
  activePlanScreen,
  noPlanActivateFlag,
  notLoggedIn,
  isLoggedInUserApproved,
}) => (
  <div className="plansDiv">
    <div className="planNameDiv">
      <p>{name}</p>
    </div>
    <div className="planContentDiv">
      <div className="paraDiv" >
      {/* <div className="paraDiv" style={{ minHeight: "40px" }}> */}
        <p>{description}</p>
      </div>
      <div className="lowerContentDiv">
        <div className="priceDiv">
          <h1>{price}/-</h1>
          {/* <p>/ For {duration} month</p> */}
        </div>
        <div className="divider" />
        <div className="lower-containt-of-plans" style={{}}>
          <div className="benefitsContentDiv">
            {benefits?.map((benefit, index) => (
              <div className="benefitPara" key={index}>
                {/* <img src={Icons.doneTickMarkIcon} alt="" /> */}
                {/* <img src={Icons.close_ico} alt="" /> */}
                {benefit?.subscription_plan_feature_flag ? (
                  <>
                    <img src={Icons.doneTickMarkIcon} alt="" />
                  </>
                ) : (
                  <>
                    <img src={Icons.close_ico} alt="" />
                  </>
                )}
                <p>{benefit?.feature_name}</p>
              </div>
            ))}
          </div>
          {!activePlanScreen && (
            <div className="buttonDiv">
              <button
                onClick={
                  noPlanActivateFlag ? onAddSubscription : onUpdateSubscription
                }
              >
                {/* {noPlanActivateFlag ? <>Get Started</> : <>Upgrade</>} */}
                {!isLoggedInUserApproved
                  ? "Join Now"
                  : noPlanActivateFlag
                  ? "Get Started"
                  : "Upgrade"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

const SubscriptionPlan = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const notLoggedIn = location?.state?.notLoggedIn;

  const navigate = useNavigate();
  const [filteredSubscriptionPlan, setFilteredSubscriptionPlan] = useState([]);
  const [activeSubscriptionData, setActiveSubscriptionData] = useState([]);
  const [noPlanActivateFlag, setNoPlanActivateFlag] = useState(true);
  const [isLoggedInUserApproved, setIsLoggedInUserApproved] = useState(null);
  const [isUserLogin, setIsUserLogin] = useState(true);
  const handleAddSubscription = (data) => {
    // not loggedin then redirect to login page
    // if (notLoggedIn) {
    //   navigate("/login");
    //   return;
    // }
    const requestData = {
      user_subscription_plan_id: data?.user_subscription_plan_id,
    };

    dispatch(
      AddSubscriptionAPI(requestData, (result) => {
        if (!isUserLogin) {
          navigate("/login");
          return;
        }
 
        if (result?.status) {
          const url = result?.data;
          if (url) {
            window.open(url, "_blank");
            //need to handlke code, after payment done => navigating user on which screen ?.
          } else {
            console.log("No URL provided in the response.");
          }
        } else {
          console.log("Subscription API call failed.");
        }
      })
    );
  };

  const handleUpdateSubscription = (data) => {
    const requestData = {
      user_subscription_plan_id: data?.user_subscription_plan_id,
    };
    dispatch(
      updateSubscriptionAPI(requestData, (result) => {
        if (result?.status) {
          const url = result?.data;
          if (url) {
            window.open(url, "_blank");
          } else {
            console.log("No URL provided in the response.");
          }
        } else {
          console.log("Subscription API call failed.");
        }
      })
    );
  };
  // Fetch active subscription data
  useEffect(() => {
    dispatch(
      getActiveSubscriptionAPI({}, (result) => {
        setActiveSubscriptionData(result || []);
       
      })
    );
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
       
        setIsLoggedInUserApproved(
          result?.data?.[0]?.user_status_name === "approved"
        );
        if (!result?.status) {
          // navigate("/login")
          setIsUserLogin(false);
        }
      })
    );
  }, [dispatch]);

  //Get subscription API
  useEffect(() => {
    dispatch(
      getSubscriptionAPI({}, (result) => {
        const plans = result?.data || [];

        if (activeSubscriptionData?.length === 0) {
          setFilteredSubscriptionPlan(plans);
        } else {
          const activeSubscriptionIds = activeSubscriptionData.map(
            (plan) => plan.user_subscription_plan_id
          );
          const activeSubscriptionPrices = activeSubscriptionData.map(
            (plan) => plan.user_subscription_plan_price
          );
          const filteredPlans = result?.data?.filter(
            (plan) =>
              !activeSubscriptionIds.includes(plan.user_subscription_plan_id) &&
              activeSubscriptionPrices.some(
                (price) => Number(plan.user_subscription_plan_price) > price
              )
          );
          setFilteredSubscriptionPlan(filteredPlans);
          setNoPlanActivateFlag(false);
        }
      })
    );
  }, [dispatch, activeSubscriptionData]);

  const renderPlanCards = (plans) => {
    return plans.map((plan, index) => (
      <PlanCard
        key={index}
        name={plan.user_subscription_plan_type_name}
        description={plan.user_subscription_plan_description}
        price={`₹${plan.user_subscription_plan_price}`}
        duration={plan.user_subscription_plan_duration_months}
        benefits={plan.features}
        onAddSubscription={() => handleAddSubscription(plan)}
        onUpdateSubscription={() => handleUpdateSubscription(plan)}
        noPlanActivateFlag={noPlanActivateFlag}
        notLoggedIn={notLoggedIn}
        isLoggedInUserApproved={isLoggedInUserApproved}
      />
    ));
  };

  return (
    <>
      {notLoggedIn ? (
        <div
          style={{
            position: "sticky",
            top: 0,
            marginBottom: "20px",
            zIndex: 200,
          }}
        >
          <div className="section-1-div">
            <HeaderBlack />
          </div>
        </div>
      ) : (
        // <OnboardingHeader />
        <div>
          {/* <HeaderBlack noLoginBtn={true} /> */}
          {/* <Header/> */}
          <div className="section-1-div">
            <HeaderBlack noLoginBtn={true} />
          </div>
        </div>

        // <div
        //   style={{
        //     position: "sticky",
        //     top: 0,
        //     marginBottom: "20px",
        //     zIndex: 200,
        //   }}
        // >
        //   <div className="section-1-div">
        //     <HeaderBlack noLoginBtn={true}/>
        //   </div>
        // </div>
      )}

      <div className="subscriptionPlanMainDiv">
        <div className="upperContaint">
          <h1>Jewelry for Every Budget</h1>
          {/* <p>
            Select the perfect plan to fit your business needs. Unlock exclusive
            features and <br />
            start growing your jewelry business today.
          </p> */}
          <p>
            Choose from a range of plans designed to fit your style and budget.
            Elevate your <br />
            jewelry collection without compromise.
          </p>
        </div>
        <div className="lowerContainerWrapper">
          <div className="lowerContaint">
            {filteredSubscriptionPlan.length > 0 ? (
              renderPlanCards(filteredSubscriptionPlan)
            ) : (
              <p>No subscription plans available.</p>
            )}
          </div>
          <div className="para-gst">
            {filteredSubscriptionPlan.length > 0 ? (
              <p>*All-exclusive price: 18% GST applied </p>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SubscriptionPlan;
